/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import Homecat from './Homecat';
import {bindActionCreators} from 'redux'; 
import * as homecatActions from '../../actions/homecatActions';
import {Auth} from 'aws-amplify';
import toastr from 'toastr'; 
import * as cursoActions from '../../actions/cursoActions';
import * as validations from '../../validations/validations';


import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';

import { Segment} from 'semantic-ui-react'; 
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import {genericFormattedForDropdown} from '../../selectors/selectors';

import {getMargenes} from '../../util/';

class ManageHomecat extends React.Component  {
    constructor(props, context) {
		
		super(props, context);
        this.state={
            homecat:{},
            errors:{},
            strings:[],
            homeImagenes:[],
            imgBanner:{
                imagePreviewUrl:null
            },
            usuarioLocal:{}
		};
	}

	componentDidMount(){
        usuarioActual(this, "homecat",true).then( (usuario)=>{
           	window.scrollTo(0, 0);
            let  usuarioLocal = this.state.usuarioLocal;
            usuarioLocal = usuario;
            this.setState({usuarioLocal:usuarioLocal});
            this.props.homecatActions.getHomecat(usuario).then( homecat=>{
               this.setState({"homecat":homecat});
            })
            .catch(error=>{
              toastr.error(error);
            }); 
            
            
            this.props.homecatActions.getImagenes(usuario).then( homeImagenes=>{
               this.setState({"homeImagenes":homeImagenes});
            })
            .catch(error=>{
              toastr.error(error);
            }); 

           this.props.cursoActions.getCursoCombo(usuario).then( ()=>{ 

           }) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 

            this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
       })
        .catch(error=>{
          toastr.error(error);
        }); 
        
        
       
	
         
    
        
	}
        
    
    
     handleChange=(event, data)=> {

        let homecat = this.state.homecat;
        let field= data.name;		
        let value=data.value;
    
       
        
        field=field.split('.');
		if(field.length==1)
      		homecat[field[0]]= value;
		else{
             if(!homecat[field[0]]){
                    homecat[field[0]]={}
                }
			homecat[field[0]][field[1]]= value;
		}
        
		
        this.setState({"homecat": homecat});
    }
     
     
  FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let homecat=this.state.homecat;
              
        if(!validations.requerido(homecat.descripcion)){
            errors.descripcion=true;
            formIsValid=false;
        }
       
    
       
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }

  

    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
        
   
        this.props.homecatActions.save(this.state.homecat, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            //this.props.navigate(-1);
        });
        
    }
    
    
    onBorrar=(id)=>{
        this.props.homecatActions.delteImagen(id, this.props.user).then(() => {
            
             this.props.homecatActions.getImagenes(this.state.usuarioLocal).then( homeImagenes=>{
                       this.setState({"homeImagenes":homeImagenes});
                })
                .catch(error=>{
                  toastr.error(error);
                }); 
            
            toastr.success("Imagen eliminada!!!.");
            //this.props.navigate(-1);
        });
        
    }

    
    HandleFileImagen=(event, data, tipo)=> {
        
        
        let tamano;
        let imagen;
        
        if(tipo===1)
            imagen = this.state.imgBanner;
        if(tipo===2)
            imagen = this.state.imgThumb;
        if(tipo===3)
            imagen = this.state.imgPresentacion;
        
        let field= data.name;		
        let value;
        
        let file = event.target.files[0];
        if (!file){
            
        
                imagen.fileReg = '';
                imagen.imagePreviewUrl='';
            
                if(tipo===1)
                    this.setState({"imgBanner": imagen});
                if(tipo===2)
                    this.setState({"imgThumb": imagen});
                if(tipo===3)
                    this.setState({"imgPresentacion": imagen});
            
            return;
        }


        if(event.target.files[0].size<=((1024*1024)*2)){
            
            imagen['fileReg'] = event.target.files[0];
            imagen['imagePreviewUrl'] = URL.createObjectURL(event.target.files[0]);
           
            if(tipo===1)
                this.setState({"imgBanner": imagen});
            if(tipo===2)
                this.setState({"imgThumb": imagen});
            if(tipo===3)
                this.setState({"imgPresentacion": imagen});
            console.log(imagen);
            return;
        }else{
            tamano= Number(event.target.files[0].size)/Number(1048576);
            imagen.fileReg = '';
            imagen.imagePreviewUrl='';
           
            if(tipo===1)
                this.setState({"imgBanner": imagen});
            if(tipo===2)
                this.setState({"imgThumb": imagen});
            if(tipo===3)
                this.setState({"imgPresentacion": imagen});

            toastr.error("El archivo que intenta anexar mide "+tamano.toFixed(2)+" Mb. No se permiten imagnees mayores a 2 Mb!!!");
            return;
        } 
         
     }
    
    
    onSaveImage=(event)=>{
            event.preventDefault();
            if(!this.FormIsValid()){
                return ;
            }
    
            var image = this.state.imgBanner.fileReg;
            if(image instanceof File){

                var form_data = new FormData();
                form_data.append('file', image);
                form_data.append('tipo', 'imgBanner');
                form_data.append('id', this.props.id);

                this.props.homecatActions.saveImagen(form_data, this.props.user).then((imagen) => {

                    
                     this.props.homecatActions.getImagenes(this.state.usuarioLocal).then( homeImagenes=>{
                       this.setState({"homeImagenes":homeImagenes});
                    })
                    .catch(error=>{
                      toastr.error(error);
                    }); 

                    
                    toastr.success("Imagen guardada correctamente!!!.");

                }).catch(error=>{
                  toastr.error(error.responseJSON.message);
                });

            }
          /*
            var image = this.state.imgThumb.fileReg;
            if(image instanceof File){

                var form_data = new FormData();
                form_data.append('file', image);
                form_data.append('tipo', 'imgThumb');
                form_data.append('id', this.props.id);

                this.props.cursoActions.saveImagen(form_data, this.props.user).then((imagen) => {

                    toastr.success("Imagen guardada correctamente!!!.");

                }).catch(error=>{
                  toastr.error(error.responseJSON.message);
                });

            }
          
            var image = this.state.imgPresentacion.fileReg;
            if(image instanceof File){

                var form_data = new FormData();
                form_data.append('file', image);
                form_data.append('tipo', 'imgPresentacion');
                form_data.append('id', this.props.id);

                this.props.cursoActions.saveImagen(form_data, this.props.user).then((imagen) => {

                    toastr.success("Imagen guardada correctamente!!!.");

                }).catch(error=>{
                  toastr.error(error.responseJSON.message);
                });

            }
          */
          

      }
    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 
		return (
            <Segment style={margenes}>
                  
                <Homecat
                    strings={this.props.strings}
                    datos={this.state.homecat}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    errors={this.state.errors}
                    onSave={this.onSave}
                    onChange={this.handleChange}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    imgBanner={this.state.imgBanner}
                    onHandleFileImagen={this.HandleFileImagen}
                    onSaveImage={this.onSaveImage}
                    homeImagenes={this.state.homeImagenes}
                    onBorrar={this.onBorrar}
                />
            
          

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    return {
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        form:state.form,
        strings:state.strings,
        idioma:state.idioma,
        cursoCombo:state.cursoCombo,
        user:state.user
    }

}

function mapDispatchToProps(dispatch){

	return {  
        
        menuActions:bindActionCreators(menuActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        homecatActions: bindActionCreators(homecatActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
         paginaActions: bindActionCreators(paginaActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            
			
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageHomecat);